/**
 * Each step's title. Focusable, so the wizard moves focus here on every step
 * change — it used to fall to <body> and a screen reader heard nothing.
 */
export function StepHeading({ title, help }: { title: string; help?: string }) {
  return (
    <div>
      <h2
        id="wizard-step-heading"
        tabIndex={-1}
        className="text-ink text-lg font-semibold focus:outline-none"
      >
        {title}
      </h2>
      {help && <p className="text-ink-muted mt-1 max-w-prose text-sm">{help}</p>}
    </div>
  )
}
